export default __webpack_public_path__ + "static/media/envasesuniversales.d82eca92.png";